export const handleOptionClick = (
  onFilterSelect,
  selectedFilters,
  setFilters,
  category,
  option
) => {
  const newState = { ...selectedFilters };
  if (newState[category] && newState[category][option]) {
    delete newState[category][option];
    if (Object.keys(newState[category]).length === 0) {
      delete newState[category];
    }
  } else {
    newState[category] = { ...newState[category], [option]: true };
  }

  setFilters(newState);
  onFilterSelect(newState);
};

export const handleToggleAction = (state, setstate, key) => {
  setstate({ ...state, [key]: !state[key] });
};

/**
 * build an iterable array for zola-ui and
 * include only selected options with associated label and value
 * and keep the same order as the filter's order
 * @param filterList - facets from a server response
 * @param selectedFilters - selected options
 * */
export const trimPillsData = ({ filterList, selectedFilters }) => {
  const selectedTagArray = {};
  const trimmedData = [];
  // associate the list of selected option values to the labels
  filterList.forEach(({ key, options }) => {
    if (selectedFilters[key]) {
      selectedTagArray[key] = {
        name: key,
        options: options.filter((n) => Object.keys(selectedFilters[key]).indexOf(n.value) > -1),
      };
    }
  });
  // build an iterable array for zola-ui component
  Object.keys(selectedTagArray).map((k) =>
    selectedTagArray[k].options.forEach((i) =>
      trimmedData.push({
        value: i.value,
        label: i.label,
        name: selectedTagArray[k].name,
      })
    )
  );
  return trimmedData;
};
